// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K94g","importantInfo":"styles_importantInfo__1ZWHH"};